module.exports = __webpack_public_path__ + "static/sketch-1-a8274515dfff128ed968fe41cf503a28.png";